import {useEffect, useState} from "preact/hooks";
import {verifyCouponByToken} from "../../data-providers/coupon-data-provider";

const CouponVerification = ({token}) => {
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setLoading(true);
        verifyCouponByToken(token).then((response) => {
            setResult(response.data);
            setLoading(false);
        });
    }, [token]);

    const isValid = result?.title === "Coupon is valid";
    const statusText = isValid ? "valid" : "invalid";

    const formatScanDate = (dateValue) => {
        if (!dateValue) {
            return "-";
        }

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) {
            return "-";
        }

        return new Intl.DateTimeFormat("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        }).format(date);
    };

    const copyTextToClipboard = async (text) => {
        if (!text) {
            return false;
        }

        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
                return true;
            }
        } catch (e) {
            // Continue to legacy fallback for mobile/in-app browsers.
        }

        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.setAttribute("readonly", "");
            textarea.style.position = "fixed";
            textarea.style.top = "-9999px";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            textarea.setSelectionRange(0, textarea.value.length);
            const copiedByCommand = document.execCommand("copy");
            document.body.removeChild(textarea);
            return copiedByCommand;
        } catch (e) {
            return false;
        }
    };

    const copyCouponId = async () => {
        if (result?.coupon_id === null || typeof result?.coupon_id === "undefined") {
            return;
        }

        const success = await copyTextToClipboard(String(result.coupon_id));
        if (success) {
            setCopied(true);
            setTimeout(() => setCopied(false), 1400);
        }
    };

    const shareCoupon = async () => {
        const shareText = [
            `Coupon ID: ${result?.coupon_id || "-"}`,
            `Coupon: ${result?.coupon_title || "-"}`,
            `Store: ${result?.valid_for?.store_name || "-"}`,
            `Date of scanning: ${formatScanDate(result?.scan_date)}`,
        ].join("\n");

        if (navigator.share) {
            await navigator.share({
                title: result?.title || "Coupon verification",
                text: shareText,
                url: window.location.href,
            });
            return;
        }

        if (navigator?.clipboard) {
            await navigator.clipboard.writeText(shareText);
            setCopied(true);
            setTimeout(() => setCopied(false), 1400);
        }
    };

    if (loading) {
        return (
            <section className={"coupon-verify-page"}>
                <div className={"coupon-verify-mobile"}>
                    <div className={"coupon-verify-status"}>
                        <h2>Verifying coupon...</h2>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={"coupon-verify-page"} style={{marginTop: '44px'}}>
            <div className={"coupon-verify-mobile"}>
                <div className={"coupon-verify-status"} style={{fontSize: '44px', fontStyle: 'normal', fontWeight: 700, lineHeight: '100%'}}>
                    <div className={"heading"}>
                        <h1>
                            <span className={"title"}>
                                <span>Coupon is</span>
                            </span>
                            <span className={isValid ? "is-valid underlined" : "is-invalid underlined"}>{statusText}</span>
                        </h1>
                    </div>
                </div>

                <div className={"coupon-verify-card coupon-id-row"} style={{height: '56px', marginTop: '32px'}}>
                    <div className={"label"} style={{fontSize: '16px', fontWeight: 500}}>Coupon ID - {result?.coupon_id || "-"}</div>
                    <button className={"copy-btn"} type={"button"} onClick={copyCouponId} aria-label={"Copy coupon id"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                            <path d="M8.9375 0H14.2699C14.8156 0 15.3398 0.219141 15.7266 0.605859L18.6441 3.52344C19.0309 3.91016 19.25 4.43438 19.25 4.98008V14.4375C19.25 15.5762 18.3262 16.5 17.1875 16.5H8.9375C7.79883 16.5 6.875 15.5762 6.875 14.4375V2.0625C6.875 0.923828 7.79883 0 8.9375 0ZM2.0625 5.5H5.5V8.25H2.75V19.25H11V17.875H13.75V19.9375C13.75 21.0762 12.8262 22 11.6875 22H2.0625C0.923828 22 0 21.0762 0 19.9375V7.5625C0 6.42383 0.923828 5.5 2.0625 5.5Z" fill="#6C64DE"/>
                        </svg>
                    </button>
                </div>

                <div className={"coupon-verify-card"}>
                    <div className={"title"} style={{fontSize: '16px', fontWeight: 500}}>Date of scanning</div>
                    <div className={"value"} style={{fontSize: '14px', fontWeight: 500}}>{formatScanDate(result?.scan_date)}</div>
                </div>

                <div className={"coupon-verify-card"}>
                    <div className={"title"} style={{fontSize: '16px', fontWeight: 500}}>{result?.coupon_title || "{Coupon title}"}</div>
                    <div className={"value"} style={{fontSize: '14px', fontWeight: 500}}>{result?.coupon_description || "{Coupon description}"}</div>
                </div>

                <div className={"coupon-verify-card"}>
                    <div className={"title"} style={{fontSize: '16px', fontWeight: 500}}>For store</div>
                    <div className={"value"} style={{fontSize: '14px', fontWeight: 500}}>{result?.valid_for?.store_name || "{Store name}"}</div>
                </div>

                
            </div>
        </section>
    );
};

export default CouponVerification;
